import axios, { AxiosError } from 'axios';
import { getApiBaseUrl } from './api';

export type LoginCredentials = {
  username: string;
  password: string;
};

export interface AuthResponse {
  access_token: string;
  user: {
    id: number;
    username: string;
    email: string;
    is_staff: boolean;
    is_superuser?: boolean;
    roles?: string[];
  };
}

export const login = async (credentials: LoginCredentials): Promise<AuthResponse> => {
  try {
    // Strip '/staff' suffix to get root API URL for auth endpoint
    const baseUrl = getApiBaseUrl().replace(/\/staff\/?$/, '');
    const response = await axios.post(`${baseUrl}/auth/login/`, credentials);
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error('An unexpected error occurred during login');
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    return JSON.parse(userStr);
  }
  return null;
};

export const isAuthenticated = (): boolean => {
  return !!getToken();
}; 